import { all, put, takeEvery } from "redux-saga/effects";
import { fetcher, getErrorMsg, handleError } from "lib/fetch";
import * as actions from "./actions";

const url = "plants"

function* loadPlant(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(url, params, token);
    yield put(actions.loadPlant.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.loadPlant.failure(getErrorMsg(error)));
  }
}

function* showPlant(action) {
  try {
    const { id, token } = action.payload;
    const res = yield fetcher.get(`${url}/${id}`, token);
    yield put(actions.showPlant.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.showPlant.failure(getErrorMsg(error)));
  }
}

function* createPlant(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/create`, params, token);
    yield put(actions.createPlant.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.createPlant.failure(getErrorMsg(error)));
  }
}

function* updatePlant(action) {
  try {
    const { params, id, token } = action.payload;
    const res = yield fetcher.post(`${url}/update/${id}`, params, token);
    yield put(actions.updatePlant.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.updatePlant.failure(getErrorMsg(error)));
  }
}

function* deletePlant(action) {
  try {
    const { id, token } = action.payload;
    yield fetcher.get(`${url}/delete/${id}`, token);
    yield put(actions.deletePlant.success(id));
  } catch (error) {
    handleError(error);
    yield put(actions.deletePlant.failure(getErrorMsg(error)));
  }
}

function* importPlant(action) {
  try {
    const { file, company_id, token, mode } = action.payload;
    const formData = new FormData();
    formData.append("file_name", file.originFileObj);
    formData.append("company_id", company_id)
    formData.append("mode", mode)

    const res = yield fetcher.upload(`${url}/import`, formData, token);
    yield put(actions.importPlant.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.importPlant.failure(getErrorMsg(error)));
  }
}

function* exportPlant(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/export`, params, token);
    yield put(actions.exportPlant.success(res.data));
    fetcher.download(res.data.data);
  } catch (error) {
    handleError(error);
    yield put(actions.exportPlant.failure(getErrorMsg(error)));
  }
}

export default function* watchPlant() {
  yield all([
    takeEvery(actions.LOAD_PLANT.REQUEST, loadPlant),
    takeEvery(actions.SHOW_PLANT.REQUEST, showPlant),
    takeEvery(actions.CREATE_PLANT.REQUEST, createPlant),
    takeEvery(actions.UPDATE_PLANT.REQUEST, updatePlant),
    takeEvery(actions.DELETE_PLANT.REQUEST, deletePlant),
    takeEvery(actions.IMPORT_PLANT.REQUEST, importPlant),
    takeEvery(actions.EXPORT_PLANT.REQUEST, exportPlant),
  ]);
}
